export { default as PlansComparison } from "./plans_comparison"


// WEBPACK FOOTER //
// ./src/views/plans_comparison/index.js